import React from 'react';
import { includes } from 'lodash';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { url } from '../../constants/routes';
import { connect } from '../../reducers/index';
import './styles.css';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import TextHero from '../../components/TextBanner';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect as reduxConnect } from '../../reducers/index';
import UnClickableScreenReader from '../../components/ScreenReader/UnClickableScreenReader';
import ClickableScreenReader from '../../components/ScreenReader/ClickableScreenReader';

class CaseStudiesPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { role: localStorage.getItem('role') || 'NONE' };

    this.clickedStudy = this.clickedStudy.bind(this);
  }

  clickedStudy(study) {
    this.context.router.history.push(`${url.CASESTUDIES}/${study}`);
  }

  render() {
    const { role, location } = this.props;

    return (
      <div className="education-module">
        <Helmet>
          <title>Case Studies</title>
        </Helmet>
        <Navigation role={role} />
        <TextHero childTitle={'Case Studies'} />
        <section
          className="no-padd"
          style={{ marginTop: '-100px', zIndex: '1' }}
        >
          <div id="maincontent" className="container">
            <UnClickableScreenReader
              text={'Identify, Assist, Refer in Action'}
            />
            <Row className="text-center">
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <h2 style={{ fontSize: '36px' }}>
                  Case Studies:{' '}
                  <span className="txt-purple">Identify</span>
                  ,&nbsp;
                  <span className="txt-green">Assist</span>
                  ,&nbsp;
                  <span className="txt-dkblue">Refer</span> in Practice
                </h2>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container">
            <UnClickableScreenReader
              text={`Identify, Assist, Refer is intended to (1) help you identify when someone is experiencing challenges to theira  mental health challenge; (2) guide you in offering assistance through conversations; and (3) facilitate help-seeking behavior by referring someone to a set of appropriate resources and services based on their need.  Let’s practice Identify, Assist, Refer. Below there are five tailored case studies. Each sample case study allows you to apply your learning in unique scenarios. Please choose a scenario you'd like to explore below. Under each scenario there is a prompt to help guide your choices. You are welcome to go through as many or even all of the scenarios for practice! `}
            />
            <Row>
              <Col xs={10} xsOffset={1} md={8} mdOffset={2}>
                <p>
                  Identify, Assist, Refer is intended to (1) help you identify when someone is experiencing challenges to their mental health challenge; (2) guide you in offering assistance through conversations; and (3) facilitate help-seeking behavior by referring someone to a set of appropriate resources and services based on their need.
                </p>
                <p>
                  Let’s practice Identify, Assist, Refer. Below there are five tailored case studies. Each sample case study allows you to apply your learning in unique scenarios. Please choose a scenario you'd like to explore below. Under each scenario there is a prompt to help guide your choices. You are welcome to go through as many or even all of the scenarios for practice!
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={4} xs={12}>
                <div
                  className="scenarioBox"
                  onClick={() => this.clickedStudy(1)}
                >
                  <ClickableScreenReader
                    handleClick={() => this.clickedStudy(1)}
                    text={
                      'Scenario 1: Cris. A Residence Don. Ideal for: Residence Life Staff.'
                    }
                  />
                  <p className="scenarioBox-text">
                    Scenario 1: Cris
                    <br />
                    <strong>A Residence Don</strong>
                    <br />
                    Ideal for: Residence Life Staff
                  </p>
                </div>
              </Col>
              <Col md={4} xs={12}>
                <div
                  className="scenarioBox"
                  onClick={() => this.clickedStudy(2)}
                >
                  <ClickableScreenReader
                    handleClick={() => this.clickedStudy(2)}
                    text={
                      'Scenario 2: Dakota. A Grad Student. Ideal for: Any Student.'
                    }
                  />
                  <p className="scenarioBox-text">
                    Scenario 2: Dakota
                    <br />
                    <strong>A Grad Student</strong>
                    <br />
                    Ideal for: Any Student
                  </p>
                </div>
              </Col>
              <Col md={4} xs={12}>
                <div
                  className="scenarioBox"
                  onClick={() => this.clickedStudy(3)}
                >
                  <ClickableScreenReader
                    handleClick={() => this.clickedStudy(3)}
                    text={
                      'Scenario 3: Denese. An Undergrad Student. Ideal for: A Professor.'
                    }
                  />
                  <p className="scenarioBox-text">
                    Scenario 3: Denese
                    <br />
                    <strong>An Undergrad Student</strong>
                    <br />
                    Ideal for: A Professor
                  </p>
                </div>
              </Col>
              <Col md={4} xs={12}>
                <div
                  className="scenarioBox"
                  onClick={() => this.clickedStudy(4)}
                >
                  <ClickableScreenReader
                    handleClick={() => this.clickedStudy(4)}
                    text={
                      'Scenario 4: Gyllena. An Undergrad Student. Ideal for: Any Student.'
                    }
                  />
                  <p className="scenarioBox-text">
                    Scenario 4: Gyllena
                    <br />
                    <strong>An Undergrad Student</strong>
                    <br />
                    Ideal for: Any Student
                  </p>
                </div>
              </Col>
              <Col md={4} xs={12}>
                <div
                  className="scenarioBox"
                  onClick={() => this.clickedStudy(5)}
                >
                  <ClickableScreenReader
                    handleClick={() => this.clickedStudy(5)}
                    text={
                      'Scenario 5: Zhang Wei. An International Student. Ideal for: Staff.'
                    }
                  />
                  <p className="scenarioBox-text">
                    Scenario 5: Zhang Wei
                    <br />
                    <strong>An International Student</strong>
                    <br />
                    Ideal for: Staff
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <div className="container text-center">
            <Row>
              <Col xs={12}>
                <Button
                  className="btn btn-blue previous"
                  onClick={() => this.props.history.goBack()}
                >
                  Previous
                </Button>
                {includes(location.search, 'completed=true') && (
                  <LinkContainer
                    to={url.TRAINING_COMPLETED}
                    className="btn btn-blue next"
                  >
                    <Button>Next</Button>
                  </LinkContainer>
                )}
              </Col>
            </Row>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

CaseStudiesPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

CaseStudiesPage.defaultProps = {
  role: {}
};

CaseStudiesPage.contextTypes = {
  router: PropTypes.object.isRequired
};

const CaseStudies = CaseStudiesPage;

export default reduxConnect.role(CaseStudies);



// WEBPACK FOOTER //
// ./src/containers/CaseStudies/index.jsx